export const PDF_PREVIEW_DEFAULT_WIDTH = 612;
